import { bytesToUnit } from '@cast/utils';

export const getNetworkCostPrecision = (v?: number): number => {
  return v && v < 1 ? 6 : 2;
};

export const trafficTickFormatter = (t: number): string => {
  const [value, valueUnit] = bytesToUnit(t);
  return `${value} ${valueUnit}`;
};
